import FundInvestment from "./FundInvestment"

export default FundInvestment
